import { render, staticRenderFns } from "./ManagementTeam.vue?vue&type=template&id=f522774c&"
import script from "./ManagementTeam.vue?vue&type=script&lang=js&"
export * from "./ManagementTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports